module.exports = __webpack_public_path__ + "img/sport-swim.7768c535.jpg";